import React from 'react'
import { Col, Form, Input, Row } from 'antd'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-query';
import { UserServices } from '../../../redux/Services';
import { GetLoggedInUser, isSuperAdmin } from '../../../utils';
import HeadingBack from '../../../component/HeadingBack';
import { usePermission } from '../../../hooks/usePermission';
import { preventHtml } from '../../../utils/validation';
import LoadingButton from '../../../component/LoadingButton';
import { useAsyncAction } from '../../../hooks/useAsyncAction';

const AddRoles = () => {
    const permission = usePermission("Users Management", "Add");
    let LOG_IN_USER = GetLoggedInUser();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { mutateAsync: addRole } = useMutation((data) => dispatch(UserServices.addRolesApi(data, navigate)));
    // Super admin creates shared roles (every organization can use them);
    // organization admins create roles for their own organization
    const superAdmin = isSuperAdmin();
    const [handleSubmit, submitting] = useAsyncAction((values) => {
            let _data = { ...values };
            _data.UserId = LOG_IN_USER?.UserId;
            return addRole(_data);
    })
    return (
        <>
            <HeadingBack title={"Role Add"} subHeading="" />
            <div className='p-20'>
                <Row>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        < Form
                            form={form}
                            name="basic"
                            layout={"vertical"}
                            autoComplete="off"
                            onFinish={handleSubmit}
                        >
                            <Form.Item
                                label="Role"
                                name="Role"
                                rules={[{ required: true, message: 'Role is required' }]}
                            >
                                <Input autoComplete="off" className='form-control' placeholder='Role' onInput={preventHtml}/>
                            </Form.Item>
                            {superAdmin && (
                                <p className='mb-10'>This role will be shared and can be used by every organization.</p>
                            )}
                            <Form.Item
                                label="Additional Field"
                                name="AdditionalInfo"
                            >
                                <Input.TextArea autoComplete="off" className='form-control' placeholder='Enter Text' rows={4} maxLength={100} onInput={preventHtml} />
                            </Form.Item>
                            <div className='text-center'>
                                <LoadingButton key="submit" type="submit" className='gradient-button w-auto' loading={submitting}>
                                    Submit
                                </LoadingButton>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default AddRoles